import type { ModelViewerPresentationSettings } from '@/constants/modelViewerPresentation';
import { presentationSettingsToModelViewerSettings } from '@/constants/modelViewerPresentation';
import { Annotation, ModelViewerSettings } from '@/types/Annotation.model';

/**
 * Merges server-loaded viewer settings with current editor state so a partial
 * update (e.g. re-upload GLB + new preview) does not drop annotations or camera.
 */
export function mergeModelViewerSettingsForUpdate(
  loaded: Partial<ModelViewerSettings> | null | undefined,
  annotations: Annotation[],
  initialCameraOrbit: string,
  initialCameraTarget: string,
  initialCameraFieldOfView: string,
  presentation?: ModelViewerPresentationSettings
): ModelViewerSettings {
  const merged: ModelViewerSettings = { ...(loaded || {}) };
  if (initialCameraOrbit) merged.initialCameraOrbit = initialCameraOrbit;
  if (initialCameraTarget) merged.initialCameraTarget = initialCameraTarget;
  if (initialCameraFieldOfView) {
    merged.initialCameraFieldOfView = initialCameraFieldOfView;
  }
  merged.annotations = annotations;
  if (presentation) {
    Object.assign(merged, presentationSettingsToModelViewerSettings(presentation));
  }
  return merged;
}
